export default __webpack_public_path__ + "static/media/site_editor.e4ac8a4b.png";